import React from 'react'
import { SimpleImg } from 'react-simple-img'
import Fade from 'react-reveal/Fade';

import akzent from '../images/akzent-logistics.png'
import arcatek from '../images/arcatek.png'
import trade from '../images/trade-unlimited.png'
import freight from '../images/akzent-freight.png'
// import cei from '../images/cei.png'

const EmpresasAkzent = () => {
	return (
		<section className="empresas-akzent">
			<div className="container">
				<Fade bottom><SimpleImg src={akzent} alt="Akzent Logistics" width={226} height={100} placeholder={false} className="img-fluid mx-auto d-block" /></Fade>
			</div>
			<ul className="cont">
				<li>
					<Fade bottom><SimpleImg src={arcatek} alt="Arcatek" width={158} height={64} placeholder={false} className="img-fluid mx-auto d-block" /></Fade>
				</li>
				<li>
					<Fade bottom><SimpleImg src={trade} alt="Trade Unlimited" width={318} height={64} placeholder={false} className="img-fluid mx-auto d-block" /></Fade>
				</li>
				<li>
					<Fade bottom><SimpleImg src={freight} alt="Akzent Freight" width={196} height={64} placeholder={false} className="img-fluid mx-auto d-block" /></Fade>
				</li>
				{/*<li>
					<Fade bottom><SimpleImg src={cei} alt="CEI" width={68} height={62} placeholder={false} className="img-fluid mx-auto d-block" /></Fade>
				</li>*/}
			</ul>
		</section>
	)
}

export default EmpresasAkzent
